module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-Medium.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-Medium.woff
 ** module id = 1107
 ** module chunks = 0
 **/